'use strict';

import L from 'external/leaflet';

export default class GeoJsonPlugin {

    init(map, o) {
        o.plugins.forEach(p => {
            if (p.path === 'map/plugins/GeoJsonPlugin') {
                try {
                    this.config = JSON.parse(p.config);
                }
                catch (e) {
                    console.error('Error in JSON', e);
                }

            }
        });

        try {
            map.addLayer(new L.geoJson(this.config, {
                weight: 2
            }));
        } catch (e) {
            console.error(e);
        }
    }
}



// WEBPACK FOOTER //
// ./js/plugins/GeoJsonPlugin.js